// extracted by mini-css-extract-plugin
module.exports = {"navBack":"NavBack_navBack__e4cZ8","customLink":"NavBack_customLink__2OCFn","arrow":"NavBack_arrow__3p-lE","left":"NavBack_left__1g079","customMargin":"NavBack_customMargin__1Qf6e"};